import { UIHeading2, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { MultiOfferContainer } from 'shared/containers/MultiOfferContainer';
import { EMappedTypeOffer } from '../../constants/mapOfferTypes';
import { ETestIds } from '../../constants/testIds';
import { FillApplicationButton } from '../../containers/stickyButtons/FillApplicationButton';
import { EFillApplicationStickyButtonType } from '../../containers/stickyButtons/FillApplicationButton/types';
import { useIsDesktop } from '../../hooks/common';
import { TMapOffersResult } from '../../types/common/offer';
import { IOfferCardProps, OfferCard } from '../OfferCard';
import styles from './styles.css';

export interface IOfferListProps {
  offersList: TMapOffersResult;
}

type TMapComponents = Record<
  EMappedTypeOffer,
  (props: IOfferCardProps | IOfferCardProps[]) => React.ReactElement | null
>;

const mapComponents: TMapComponents = {
  offer: (props: IOfferCardProps) => <OfferCard {...props} />,
  multi: (props: IOfferCardProps[]) => <MultiOfferContainer multiOffers={props} />,
};

export const OfferList: React.FC<IOfferListProps> = ({ offersList }) => {
  const deviceType = useDeviceType();
  const isDesktop = useIsDesktop();

  return (
    <div className={cn(styles['container'], styles[deviceType])} data-testid={ETestIds.OfferListContainer}>
      {!isDesktop && (
        <div className={cn(styles['title'])} data-testid={ETestIds.OfferListTitle}>
          <UIHeading2>Ваши предложения</UIHeading2>
        </div>
      )}
      <ul className={cn(styles['list'], styles[deviceType])} data-testid={ETestIds.OfferList}>
        {offersList.map(({ type, content }, index) => {
          return <li key={index}>{mapComponents[type](content)}</li>;
        })}
      </ul>
      {isDesktop && <FillApplicationButton currentButtonType={EFillApplicationStickyButtonType.TOP} />}
    </div>
  );
};
